import { List } from 'immutable';

import State from '../core/State';
import AmazonAdAccount from '../entity/AmazonAdAccount';
import initialState from '../initialState';

export const setAmazonAdAccounts = (amazonAdAccounts: List<AmazonAdAccount>) => (state: State): State => ({
  ...state,
  amazonAdAccounts,
});

export const setAmazonUploadedCreative = (amazonUploadedCreative: boolean) => (state: State): State => ({
  ...state,
  amazonUploadedCreative,
});

export const setAmazonAdAccountTokenId = (tokenId: string) => (state: State): State => ({
  ...state,
  integratedAmazonAdAccounts: {
    ...state.integratedAmazonAdAccounts,
    tokenId,
  },
});

export const startIntegratedAmazonAdAccounts = () => (state: State): State => ({
  ...state,
  integratedAmazonAdAccounts: {
    ...state.integratedAmazonAdAccounts,
    fetching: state.integratedAmazonAdAccounts.fetching + 1,
  },
});

export const setIntegratedAmazonAdAccounts = (integratedAmazonAdAccounts: List<AmazonAdAccount>) => (
  state: State,
): State => ({
  ...state,
  integratedAmazonAdAccounts: {
    ...state.integratedAmazonAdAccounts,
    adAccounts: integratedAmazonAdAccounts,
    fetching: state.integratedAmazonAdAccounts.fetching - 1,
  },
});

export const finishIntegratedAmazonCommunication = () => (state: State): State => ({
  ...state,
  integratedAmazonAdAccounts: {
    ...state.integratedAmazonAdAccounts,
    fetching: state.integratedAmazonAdAccounts.fetching - 1,
  },
});

export const disposeAmazonAdAccounts = () => (state: State): State => ({
  ...state,
  amazonAdAccounts: initialState.amazonAdAccounts,
});
